import PropTypes from 'prop-types'
import React, { Component } from 'react'

import CodeForm from 'components/codeForm/codeForm'
import { localize } from 'helpers/translator'

class Join extends Component {
	render() {
		const initialValues = {codeField: this.props.pinCode.toUpperCase()}
		return (
			<CodeForm
				placeholder={localize('code_placeholder')}
				color={this.props.color}
				maxLength='7'
				shouldDisplayUppercase={true}
				activeStyle={false}
				button={{ text: localize('global_join') }}
				uid='join'
				formKey={this.props.formKey}
				initialValues={initialValues} />
		)
	}
}

Join.defaultProps = {
	formKey: '0',
	color: 'yellow',
	pinCode: '',
}

Join.propTypes = {
	formKey: PropTypes.string,
	color: PropTypes.string,
	pinCode: PropTypes.string,
}

export default Join

